import {
  AccountLockupProps,
  AvatarProps,
  AccountLockup as DSAccountLockup,
} from "@opensea/ui-kit"
import React from "react"
import { AvatarImage } from "../Avatar"

const AccountLockupAvatar = (props: Omit<AvatarProps, "src">) => {
  return <DSAccountLockup.Avatar {...props} renderImage={AvatarImage} />
}

const AccountLockupBase = (props: AccountLockupProps) => {
  return <DSAccountLockup {...props} />
}

export const AccountLockup = Object.assign(AccountLockupBase, {
  Avatar: AccountLockupAvatar,
  Text: DSAccountLockup.Text,
  Badge: DSAccountLockup.Badge,
})
